import { ESliderSizes } from '@/app/(home)/components/Slider/Slider.types';
import { Collection, CollectionContent } from '@/types/collection.types';
import { IItem } from '@/types/feed.types';

export enum EAspect {
  SQUARE = 'square',
  DEFAULT = 'default',
}

export enum ECardSizes {
  S = 'S',
  M = 'M',
  L = 'L',
}

export enum ECardType {
  COLLECTION = 'collection',
  ITEM = 'item',
}

export interface IPreviewCard {
  data: IItem | Collection | CollectionContent;
  size?: ECardSizes | ESliderSizes;
  aspect?: EAspect;
  innerRef?: (node?: Element | null | undefined) => void;
  playlistId?: string | null;
  searchString?: string | null;
  collectionId?: string | null;
  isHome?: boolean;
  cardTitle?: string;
  showCreatedTime?: boolean;
  showMetadata?: boolean;
  priority?: boolean;
  previewSource?: string;
}

export interface IItemCardProps {
  data: IItem | CollectionContent;
  size?: ECardSizes | ESliderSizes;
  innerRef?: (node?: Element | null | undefined) => void;
  playlistId?: string | null;
  searchString?: string | null;
  collectionId?: string | null;
  isHome?: boolean;
  cardTitle?: string;
  showCreatedTime?: boolean;
  showMetadata?: boolean;
  priority?: boolean;
  previewSource?: string;
}

export interface ICollectionCardProps {
  data: Collection;
  innerRef?: (node?: Element | null | undefined) => void;
}

export enum EMediaEndpointsTypes {
  IMAGE = 'image-poster',
  HLS = 'video-hls',
  DASH = 'video-dash',
  FNHLS = 'fn-hls',
  FNDASH = 'fn-dash',
}
